import * as Types from '../../tenants/kwg/generated';


export const UserSettingFragmentDoc = `
    fragment UserSetting on UserSetting {
  key
  value
}
    `;
// @ts-ignore
// auto-added to satisfy TS unused import
void 0 && Types;
